import { memo } from 'react';
import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * "Partial · n of m" badge of a parent permission with only some children on.
 *
 * @param {object} props
 * @param {number} props.on Children that are on.
 * @param {number} props.total Children in total.
 */
const PartialBadge = ({ on, total }) => {
  const { t } = useTranslation('people-access');
  return (
    <Badge size="small" variant="warning">
      {t('permissionTree.partial', { on, total })}
    </Badge>
  );
};

export default memo(PartialBadge);
